module.exports = __webpack_public_path__ + "static/media/face-liveness.5ee30741.jpg";